export const LENDERS = [
  "Accord",
  "Afin",
  "AIB",
  "Aldermore Mortgages",
  "April Mortgages",
  "Atom Bank",
  "Bank Of Ireland",
  "Barclays Bank",
  "Bath BS",
  "Beverley BS",
  "Bluestone Mortgages",
  "BM Solutions",
  "Buckinghamshire BS",
  "Cambridge BS",
  "Central Trust Limited",
  "CHL Mortgages",
  "Chorley BS",
  "Clydesdale Bank",
  "Coventry BS",
  "Cumberland Building Society",
  "Danske Bank",
  "Darlington BS",
  "Dudley BS",
  "Earl Shilton BS",
  "Ecology Building Society",
  "Equifinance",
  "Family Building Society (NCBS)",
  "Fleet Mortgages",
  "Foundation",
  "Furness BS",
  "Gen H",
  "Godiva Mortgages",
  "Halifax",
  "Hampshire Trust Bank",
  "Hanley Economic BS",
  "Harpenden BS",
  "Hinckley & Rugby for Intermediaries",
  "Hodge",
  "HSBC",
  "Interbay",
  "Kensington Mortgages",
  "Keystone",
  "Landbay",
  "Leeds BS",
  "Leek Building Society",
  "Lendco",
  "LendInvest Mortgages",
  "LiveMore",
  "Loughborough BS",
  "Mansfield BS",
  "Market Harborough BS",
  "Marsden BS",
  "Melton Building Society",
  "Mercantile Trust",
  "Metro Bank",
  "Moda Mortgages",
  "Molo Finance",
  "Monmouthshire BS",
  "MT Finance",
  "Nationwide BS",
  "NatWest",
  "Newcastle for Intermediaries",
  "Newbury BS",
  "Nomo",
  "Norton Home Loans",
  "Nottingham BS",
  "Octopus Real Estate",
  "Paragon Banking Group PLC",
  "Penrith BS",
  "Pepper Money",
  "Perenna",
  "Precise Mortgages",
  "Principality BS",
  "Progressive BS",
  "Quantum Mortgages",
  "Rely Mortgages",
  "Saffron BS",
  "Santander UK Plc",
  "Scottish BS",
  "Scottish Widows Bank",
  "Selina Finance",
  "Skipton BS",
  "Skipton International",
  "State Bank of India UK",
  "Step One Finance",
  "Suffolk Building Society",
  "Swansea BS",
  "Tandem Bank",
  "Teachers BS",
  "The Co-operative Bank (Including Platform)",
  "The Mortgage Lender",
  "The Mortgage Works",
  "The Stafford for Intermediaries",
  "Tipton & Coseley BS",
  "Together",
  "TSB",
  "United Trust Bank",
  "Vernon BS",
  "Vida Homeloans",
  "Virgin Money",
  "West Brom Building Society",
  "West Brom Commercial Limited",
  "West One Loans",
  "Yorkshire Building Society",
  "Zephyr Homeloans",
];
